import type { AxiosError, InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';

const TOKEN_KEY = 'lessoncraft_token';

let rateLimitToastShown = false;

const showRateLimitToast = () => {
  if (!rateLimitToastShown) {
    rateLimitToastShown = true;
    const event = new CustomEvent('lessoncraft:ratelimit', {
      detail: { message: 'Too many requests. Please slow down.' },
    });
    window.dispatchEvent(event);
    setTimeout(() => {
      rateLimitToastShown = false;
    }, 5000);
  }
};

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem('lessoncraft_user');
      window.location.href = '/login';
    } else if (error.response?.status === 429) {
      showRateLimitToast();
    }
    return Promise.reject(error);
  }
);

export default api;
